var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card relative"},[(_vm.admin)?_c('div',{staticClass:"absolute top-2 right-2 px-1 rounded bg-gray-50 border border-gray-300 text-gray-500 text-sm uppercase"},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }